module.exports = __webpack_public_path__ + "img/cps.840a1b81.svg";